export const ANIMATION_DURATION = 100;

export const ROTATION_AMOUNT = 0.5;
export const ROTATION_UNITS = "deg";

export const MIN_ROTATION = `-${ROTATION_AMOUNT}${ROTATION_UNITS}`;
export const MAX_ROTATION = `${ROTATION_AMOUNT}${ROTATION_UNITS}`;
